export default __webpack_public_path__ + "static/media/i2.65b41c80.png";